export default __webpack_public_path__ + "static/media/feedback.0f8c2c59.jpeg";